var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-692 -542)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(692 556)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(700 542)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(708 558)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-3406.481,7586.565l4.332-7.421",
    transform: "translate(4104 -7030)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-3404.106,7590.417l8.5,1.02",
    transform: "translate(4104 -7030)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkText);
export default __webpack_public_path__ + "static/media/link-text.d4847c5f.svg";
export { ForwardRef as ReactComponent };